import { message, Modal } from 'antd';
import {
  AddInvestorRequest,
  createInvestor,
  CreateInvestorOptions,
  InvestorProfile,
} from '@/api/custom';
import {
  getInvestorSubmitErrorStatus,
  getInvestorSubmitResponseDetailType,
} from './investor-submit-error-utils';

export class ArchivedInvestorRestoreCanceledError extends Error {
  constructor() {
    super('Client was not added back.');
    this.name = 'ArchivedInvestorRestoreCanceledError';
  }
}

export const isArchivedInvestorCreateInvestorError = (error: unknown): boolean =>
  getInvestorSubmitErrorStatus(error) === 409 &&
  getInvestorSubmitResponseDetailType(error) === 'ARCHIVED_INVESTOR_EXISTS';

export const confirmArchivedInvestorRestore = () =>
  new Promise<boolean>((resolve) => {
    Modal.confirm({
      title: 'Client previously removed',
      content:
        "A client with this email was removed before. If you continue, we'll add them back to your client list using their existing record.",
      okText: 'Add client back',
      cancelText: 'Cancel',
      onOk: () => {
        resolve(true);
      },
      onCancel: () => {
        resolve(false);
      },
    });
  });

export const createInvestorWithArchivedRestore = async (
  data: AddInvestorRequest,
  options: CreateInvestorOptions = {},
): Promise<InvestorProfile> => {
  try {
    return await createInvestor(data, options);
  } catch (error) {
    if (!isArchivedInvestorCreateInvestorError(error)) {
      throw error;
    }

    const shouldRestore = await confirmArchivedInvestorRestore();
    if (!shouldRestore) {
      throw new ArchivedInvestorRestoreCanceledError();
    }

    const restoredInvestor = await createInvestor(data, {
      ...options,
      restoreArchived: true,
    });
    message.success('Client added back to your list.');
    return restoredInvestor;
  }
};
